import { render } from "./Mitglied.vue?vue&type=template&id=4b92864e&scoped=true"
import script from "./Mitglied.vue?vue&type=script&lang=js"
export * from "./Mitglied.vue?vue&type=script&lang=js"

import "./Mitglied.vue?vue&type=style&index=0&id=4b92864e&scoped=true&lang=css"

import exportComponent from "C:\\Git-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b92864e"]])

export default __exports__